import jwtDecode from "jwt-decode"

import * as types from "../types/userAccountInfo"
import { getUserAccountInfo } from "services"
import { getUserAccesses } from "utils"

export const fetchUserAccountInfo = () => (
  async (dispatch) => {
    const {
      accessList,
      accessIds,
      ...userAccountDetails
    } = await getUserAccountInfo()

    const decodedToken = jwtDecode(localStorage.at)

    const accesses = getUserAccesses(accessList)

    dispatch({
      type: "FETCH_USER_INFO",
      userAccountInfo: {
        ...userAccountDetails,
        accesses,
        role: decodedToken.role
      }
    })
  }
)

export const updateUserAccountInfo = userAccountInfo => ({
  type: types.UPDATE_USER_INFO,
  userAccountInfo
})

export const deleteUserAccountInfo = () => ({
  type: types.DELETE_USER_INFO
})